import PropTypes from "prop-types";
import "./TextBtn.css";

export default function TextBtn({ className, label, onClick, icon, disabled }) {
	return (
		<button
			type="button"
			className={`text-btn ${className || ""}`}
			onClick={onClick}
			disabled={disabled}
		>
			{icon}
			{label}
		</button>
	);
}

TextBtn.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	icon: PropTypes.element,
	disabled: PropTypes.bool,
};
